import React from "react";

export function Projects() {
    return (
      <main>
        <section className="projects">
          <h1>Projects</h1>
          <article>
            <h2>Power BI to Amazon QuickSight Migration</h2>
            <p><strong>Client:</strong> Rocket Learning</p>
            <p>Migrated dashboards from Power BI to Amazon QuickSight.</p>
          </article>
          <article>
            <h2>AI-Powered Chatbot for Supply Chain Analysis</h2>
            <p><strong>Client:</strong> FMCG Ltd</p>
            <p>Developed an AI chatbot to analyze supply chain data.</p>
          </article>
        </section>
      </main>
    );
  }